import React, { Component } from "react";
import { Link } from "react-router-dom";
import Dropdown from "../component/Dropdown";
import TextField from "../component/TextField";
import FpgDeleteIcon from "../icons/fpgdeleteicon";
import FpgDisableIcon from "../icons/fpgdisableicon";
import FpgeeditIcon from "../icons/fpgediticon";
import FpgpublishIcon from "../icons/fpgpublishicon";
import PlusIcon from "../icons/plusicon";
import MainLayout from "../mainLayout";
import PopUpCustomAll from "../component/fpg/create/popUpCustomAll";
import VideoImageFile from "../component/VideoImageFile";
import Loader from "../component/loader";
import commonImage from '../commonImage';
//Service import
import service from "../services";
//Validation import
import SimpleReactValidator from "simple-react-validator";

// Editors
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

//Redux Connect
import { connect } from "react-redux";
import moment from "moment";
import TextEditor from "../component/TextEditor";
let sub;

const mapStateToProps = (state) => ({
  StoreProductEditList: state.StoreProductEditList,
  StoreProductEditVarientId: state.StoreProductEditVarientId,
  
});

// const mapDispatchToProps = (dispatch) => {
//   return bindActionCreators(ActCreators, dispatch);
// };
class productstoredetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      getAlldataProductEditList: [],
      loaderFlag: false,
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
      onSale: false,
      onSoldOut: "",
      name: "",
      onSale: false,
      onSoldOut: "",
      summary: EditorState.createEmpty(),
      desc: EditorState.createEmpty(),
      price: "",
      changeCategoryTitleName: false,
      getLastUpdated: "",
      discardPopup: false
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  componentDidMount() {
    console.log('this.props.StoreProductEditList:::',this.props.StoreProductEditList,this.props.StoreProductEditVarientId);
    this.getAllProductEditListdetails();
    this.getProductEditListdetails();
    this.getLastUpdatedTimeandDate();
    this.setState({
      loaderFlag: true,
    });
  }

  closeAdminUser = () => {
    this.setState({
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
      discardPopup: false,
      onSale: false
    });
  };

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  getProductEditListdetails = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "ticketCms|storeProducts|getDetail":

          if (this.state.desc) {
            const blocksFromHtml = htmlToDraft(response.data.desc ? response.data.desc : "");
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const desc = EditorState.createWithContent(contentState);
            this.setState({
              desc
            });
          }

          if (this.state.summary) {
            const blocksFromHtml = htmlToDraft(response.data.summary ? response.data.summary : "");
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const summary = EditorState.createWithContent(contentState);
            this.setState({
              summary
            });
          }
          response.data.map(item => {
            this.setState(
              {
                getAlldataProductEditList: item,
                name: item.name,
                // summary: item.summary,
                price: item.variants.price,
                variantsName: item.variants.name,
                // desc: item.desc,
                // accessType: item.accessType,
                active: item.variants.active,
                image:item.variants.image && item.variants.image.inSite,
                // onSoldOut: item.globalSoldOut,
                eventiveId: item.eventiveId,
                eventiveVarientId: item.variants.eventiveId,
              },
              () => {
                this.setState({
                  loaderFlag: false,
                });
              }
            );
          })
          break;
          case "ticketCms|storeProducts|create":
            if (response.error === true) {
              this.setState({
                loaderFlag: false,
                errorMsg: true,
                errorMsgShow: response.data.error,
              });
            } else {
              this.setState({
                loaderFlag: false,
              }, () => this.apiserve.success("Product Created successfully.")) || this.props.history.push({ pathname: "/store-listupsell-product" })
            }
  
            break;
        case "ticketCms|storeProducts|update":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState({
              loaderFlag: false,
            }, () => this.apiserve.success("Products updated successful.")) || this.props.history.push({ pathname: "/store-listupsell-product" })
          }

          break;
        case "ticketCms|storeProducts|remove":
          this.props.history.push("/store-listupsell-product");
          break;
        case "ticketCms|storeProducts|updateStatus":
          this.props.history.push("/store-listupsell-product");
          break;
        case "ticketCms|storeProducts|getLastUpdated":
          this.setState({
            getLastUpdated: response.data,
          },() => {
            this.setState({
              loaderFlag: false,
            });
          });
          break;
        case "ticketCms|products|globalSoldOut":
          if (response.error === false) {
            this.setState({ onSale: false, onSoldOut: response.data.globalSoldOut })
          }
          break;
      }
    });
  };

  getLastUpdatedTimeandDate = () => {
    this.apiserve.sendevent("ticketCms|storeProducts|getLastUpdated", { });
  };

  getAllProductEditListdetails = () => {
    var storeProductId = this.props.StoreProductEditList;
    var variantId = this.props.StoreProductEditVarientId;
    if(storeProductId && variantId){
      this.apiserve.sendevent("ticketCms|storeProducts|getDetail", { storeProductId, variantId });
    }
  };

  soldOutYes = () => {
    this.apiserve.sendevent("ticketCms|products|globalSoldOut", {
      storeProductId: this.props.StoreProductEditList,
      variantId: this.props.StoreProductEditVarientId,
      "globalSoldOut": !this.state.onSoldOut
    });
  };
  deleteFilm = () => {
    this.setState({
      deleteFilm: true,
    });
  };

  soldOutFilm = () => {
    this.setState({
      onSale: !this.state.onSale,
    });
  };

  soldOutYes = () => {
    this.apiserve.sendevent("ticketCms|products|globalSoldOut", {
      storeProductId: this.props.StoreProductEditList,
      variantId: this.props.StoreProductEditVarientId,
      "globalSoldOut": !this.state.onSoldOut
    });
  };
  deleteFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|storeProducts|remove", {
      storeProductId: this.props.StoreProductEditList,
      variantId: this.props.StoreProductEditVarientId,
    });
  };

  publishFilm = () => {
    this.setState({
      publishFilm: true,
    });
  };

  publishFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|storeProducts|updateStatus", {
      storeProductId: this.props.StoreProductEditList,
      variantId: this.props.StoreProductEditVarientId,
      active: 1,
    });
  };

  disableFilm = () => {
    this.setState({
      disableFilm: true,
    });
  };
  soldOutFilm = () => {
    this.setState({
      onSale: !this.state.onSale,
    });
  };


  disableFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|storeProducts|updateStatus", {
      storeProductId: this.props.StoreProductEditList,
      variantId: this.props.StoreProductEditVarientId,
      active: 2,
    });
  };

  discardPopupYes = () => {
    this.props.history.push({
      pathname: "/store-listupsell-product"
    })
  }

  submitFn = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      if (this.props.StoreProductEditList && this.props.StoreProductEditVarientId) {
      const name = convertToRaw(this.state.summary.getCurrentContent());
      const summary = draftToHtml(name);
      const make = convertToRaw(this.state.desc.getCurrentContent());
      const desc = draftToHtml(make);
      let updateproducts = {
        productName: this.state.name,
        price: this.state.price,
        productVariantName: this.state.variantsName,
        storeProductId: this.props.StoreProductEditList,
        variantId: this.props.StoreProductEditVarientId,
        // active: this.state.active,
        eventiveId: this.state.eventiveId,
        eventiveVariantId: this.state.eventiveVarientId,
        image:{inSite:this.state.image}
      };
      this.apiserve.sendevent("ticketCms|storeProducts|update", updateproducts);
      }
      else{
        let AddProducts = {
          productName: this.state.name,
          price: parseInt(this.state.price),
          productVariantName: this.state.variantsName,
          // active: this.state.active,
          eventiveId: this.state.eventiveId,
          eventiveVariantId: this.state.eventiveVarientId,
          image: { inSite: this.state.image }
        }
        this.apiserve.sendevent("ticketCms|storeProducts|create", AddProducts);
      }
    }else{
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };

  cancel = () => {
    this.setState({
      discardPopup: true
    })
  }
  onEditorStateChange = summary => {
    this.setState({
      summary
    });
  };
  onEditorState = desc => {
    this.setState({
      desc
    });
  };
  onChangeFile = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);    reader.onloadend = (event) => {
      this.setState({
        file: file
        // base64: reader.result
      });
      if (
        (file && file.type === "image/png") ||
        (file && file.type === "image/jpg") ||
        (file && file.type === "image/jpeg")
      ) {
        const fileList = Math.round(file && file.size / 1024);
        if (fileList >= 2048) {
          this.setState({
            errorMsg: true,
            errorMsgShow: "Please upload a file smaller than 2 MB"
          });
          return false;
        }
        if (file && (file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg")) {
              // this.setState({ isImage: true });
            setTimeout(() => {
              this.uploadVideoImage(file, id,event.target.result);
            }, 0);
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: "Please Upload PNG/JPEG of max size of 2MB"
          });
        }
      } else {
       
          this.setState({
            errorMsg: true,
            errorMsgShow: "Please Upload PNG/JPEG of max size of 2MB"
          });

        // if (file.type === "video/mp4") {
        //   setTimeout(() => {
        //     this.uploadVideoImage(file, id);
        //   }, 0);
        //   return false;
        // } else {
        //   this.setState({
        //     errorPopup: true,
        //     errorMsg: "Please Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB"
        //   });
        // }
      }
    };
  };
  uploadVideoImage = (file, id, img) => {
    const imagePreloaderId = `imagePreloader_${id}`;
    const newState = { ...this.state, videoPreLoader: true };
    newState[imagePreloaderId] = true;
    this.setState(newState);
    var fileSet= commonImage(file,false,'',img)
     fileSet.then((value) => {
      // this.state.image.forEach(image => {
      //   const imagePreloaderId = `imagePreloader_${id}`;
      //   const newState = { ...this.state };
      //   newState[imagePreloaderId] = false;
      //   this.setState(newState);

      //   if (image._id === id) {
      //     image.media = data.Key;
      //   }
      // });
      this.setState({image: process.env.REACT_APP_IMAGE_URL + value});
    });
  };
  render() {
    const { getLastUpdated } = this.state;
    console.log();
    var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
    var hour = moment(updateAt).format("h");
    var minutes = moment(updateAt).format("mm");
    var state = moment(updateAt).format("A");
    var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
    return (
      <React.Fragment>
        <div className="right_side_wrapper">
          <ul className="fpg_admin_tab disp_flex">
            {this.state.data &&
              this.state.data.map((list, index) => {
                return (
                  <li className="active">
                    <p className="uppercase text_left">
                      {list.label}
                      <Link to="create-film">
                        <PlusIcon />
                      </Link>
                    </p>
                  </li>
                );
              })}
          </ul>

          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
            <Link className="back_link" to="/store-listupsell-product">
              {" "}
              <svg width="5" height="10" viewBox="0 0 5 10" fill="none">
                {" "}
                <path d="M5 0L0 5L5 10V0Z" fill="black" />{" "}
              </svg>{" "}
              Back to List
              </Link>
            <p className="update_date">
              Last Update: {hour}:{minutes} {state} -{" "}
              {moment(updateAt).format("MM/DD/YYYY")} Last Updated By:{" "}
              {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}
            </p>
          </div>
          <div className="product_detail_content fpg_tabcontent">
            <form>
              <div className="d_flex product_wrap_content">
                <div className="product_form product_coupon_form">
                <div className="field_row horizontal_field">
                    <TextField
                      type="text"
                      label="Eventive ID"
                      name="eventiveId"
                      value={this.state.eventiveId}
                      // disable
                      onChange={this.onInputChange}
                      fpgerror={this.validator.message('Eventive ID',this.state.eventiveId,'required')}
                    />
                  </div>
                  <div className="field_row horizontal_field">
                    <TextField
                      type="text"
                      label="Eventive Variant Id"
                      name="eventiveVarientId"
                      value={this.state.eventiveVarientId}
                      // disable
                      onChange={this.onInputChange}
                      fpgerror={this.validator.message('Eventive Variant Id',this.state.eventiveVarientId,'required')}
                    />
                  </div>
                  <div className="field_row horizontal_field">
                    <TextField
                      type="text"
                      label="Product Name"
                      name="name"
                      value={this.state.name}
                      onChange={e => this.onInputChange(e)}
                      fpgerror={this.validator.message('Product Name',this.state.name,'required')}
                    />
                  </div>
                  <div className="field_row horizontal_field">
                    <TextField
                      type="text"
                      label="Product Variant Name"
                      name="variantsName"
                      value={this.state.variantsName}
                      // disable
                      onChange={e => this.onInputChange(e)}
                      fpgerror={this.validator.message('Product Variant Name',this.state.variantsName,'required')}
                    />
                  </div>
                  {/* <div className="field_row horizontal_field">
                    <div className="field_row_inner">
                      <label>Product Summary</label>
                      <div className="field_input relative">
                        <TextEditor
                          editorState={this.state.summary}
                          name="summary"
                          value={this.state.summary}
                          onEditorStateChange={this.onEditorStateChange}
                        />
                        {/* <textarea
                            name="summary"
                            value={this.state.summary}
                            rows="5"
                            onChange={this.onInputChange}
                          ></textarea> 
                      </div>
                    </div>
                  </div>
                  <div className="field_row horizontal_field">
                    <div className="field_row_inner">
                      <label>Product Detail</label>
                      <div className="field_input relative">
                        <TextEditor
                          editorState={this.state.desc}
                          name="desc"
                          value={this.state.desc}
                          onEditorStateChange={this.onEditorState}
                        />
                        {/* <textarea
                            name="desc"
                            className="prod_detail"
                            rows="5"
                            value={this.state.desc}
                            onChange={this.onInputChange}
                          ></textarea> 
                      </div>
                    </div>
                  </div> */}
                  <div className="field_row horizontal_field">
                    <div className="field_row_inner">
                      <label>Product Price(USD)</label>
                      <div className="field_input relative price_field varient_price">
                       <div>
                       <input
                          type="text"
                          name="price"
                          value={this.state.price}
                          // disabled={true}
                          onChange={this.onInputChange}
                        />
                       </div>
                      <span className="price_symbol" style={{top:`${this.validator.message('price',this.state.price,'required') ? '21px' : '20px'}`}}>$</span> 
                      <span className="error">{this.validator.message('price',this.state.price,'required')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="field_row horizontal_field input_img">
                      <div className='uploads_files'>
                        <label></label>
                        <div className=" file_upload_400 relative">
                                              <div className="uploads_files store_img">
                                                <VideoImageFile
                                                  // item={item._id}
                                                    handleImage={e => this.onChangeFile(e, )}
                                                  //   iconDelete={true}
                                                  //   size="2"
                                                  //   id={item._id}
                                                    // image={this.state.image}
                                                  //   showDeleteIcon={item.media}
                                                    value={this.state.image}
                                                  //   insideOnchange={e => self.insideFilechange(e, item._id)}
                                                  //   videoPreLoader={self.state[imagePreloaderState]}
                                                  //   deleteImage={e => self.setDeleteFilePopup(e, item._id)}
                                                  isOnlyImage={true}
                                                    isboth={false}
                                                    textChange={true}
                                                  />
                                                  <span className="error">{this.validator.message('image',this.state.image,'required')}</span>
                                            </div>
                                          </div>
                      </div>
                  </div>
                  
                </div>
                <div className="product_actions">
                  <div className="fpg_edits_links d_flex d_flex_align_center">
                    {/* <Link className="d_flex d_flex_align_center d_flex_justify_center"><FpgeeditIcon />EDIT</Link> */}
                    {/* {this.state.onSoldOut ?
                      <Link
                        className="d_flex d_flex_align_center d_flex_justify_center"
                        onClick={() => this.soldOutFilm()}
                      >
                        <FpgpublishIcon /> ON SALE
                  </Link>
                      :
                      <Link
                        className="d_flex d_flex_align_center d_flex_justify_center"
                        onClick={() => this.soldOutFilm()}
                      >
                        <FpgDisableIcon /> Mark as Sold Out
                    </Link>

                    } */}
                    {this.state.active === 1 ?
                      <Link
                        className="d_flex d_flex_align_center d_flex_justify_center"
                        onClick={() => this.disableFilm()}
                      >
                        <FpgDisableIcon /> DISABLE
                    </Link>
                      :
                      <Link
                        className="d_flex d_flex_align_center d_flex_justify_center"
                        onClick={() => this.publishFilm()}
                      >
                        <FpgpublishIcon /> PUBLISH
                  </Link>
                    }
                    <Link
                      className="d_flex d_flex_align_center d_flex_justify_center"
                      onClick={() => this.deleteFilm()}
                    >
                      <FpgDeleteIcon />
                      DELETE
                      </Link>
                  </div>
                </div>
              </div>
              <div className="text_center field_row w_100 buttons_outer">
                <button className="uppercase" onClick={e => this.cancel(e)} type="button">CANCEL</button>
                <button
                  className="uppercase active"
                  onClick={(e) => this.submitFn(e)}
                >
                  SAVE
                  </button>
              </div>
            </form>
          </div>
        </div>
        {this.state.onSale ? (
          this.state.onSoldOut ? (
            <PopUpCustomAll
              HeaderName="On Sale?"
              insideDetails="You are about to put the product On Sale. This will make it available to purchase on the site."
              insideData="Do you want to proceed?"
              popupState={this.closeAdminUser}
              yesPopUp={this.soldOutYes}
            />
          ) : (
              <PopUpCustomAll
                HeaderName="Mark as Sold Out?"
                insideDetails="You are about to mark the product as Sold Out. This will prevent anyone from purchasing it."
                insideData="Do you want to proceed?"
                popupState={this.closeAdminUser}
                yesPopUp={this.soldOutYes}
              />
            )
        ) : (
            // <PopUpCustomAll
            //   HeaderName="Mark as Sold Out?"
            //   insideDetails="You are about to mark the product as Sold Out. This will prevent anyone from purchasing it."
            //   insideData="Do you want to proceed?"
            //   popupState={this.closeAdminUser}
            //   yesPopUp={this.soldOutYes}
            // />
            ''
          )}
          
        {this.state.deleteFilm ? (
          <PopUpCustomAll
            HeaderName="Delete?"
            insideDetails="You are about to delete an item and this action is permanent"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.deleteFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.publishFilm ? (
          <PopUpCustomAll
            HeaderName="Publish Changes"
            insideDetails="Saving the current changes will publish it to the production site"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.publishFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.disableFilm ? (
          <PopUpCustomAll
            HeaderName="Disable?"
            insideDetails="You are about to disable an item, which will temporarily make it unavailable on the production site"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.disableFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.discardPopup ? (
          <PopUpCustomAll
            HeaderName="Discard Changes?"
            insideDetails="Leaving this page without saving will discard all changes"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.discardPopupYes}
          />
        ) : (
            ""
          )}
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, null)(productstoredetail);
